import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import Vuetify from 'vuetify'
import VueSimpleAlert from 'vue-simple-alert'

Vue.use(VueSimpleAlert, { title: 'Vue Simple Alert', width: '420px' })
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(ElementUI, { locale })
Vue.use(Vuetify)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js